import { Navigate } from 'react-router-dom';
import React from 'react';

import { STATIC_PAGES } from '@/router/routeInitial.state';
import { useAuthenticate } from '@/context/AuthenticateContext';

export const ProtectedAuthRoutes = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const { isLoggedIn } = useAuthenticate();
  if (!isLoggedIn) return <Navigate to={STATIC_PAGES.SIGN_IN.path} />;
  return <>{children}</>;
};
